import { useEffect } from "react";
import { useAgencies } from "../../hooks/useAgencies";
import { useSessionUserDetails } from "../../hooks/useUserDetails";
import { getCurrentFbo, getUserToken, setCurrentFbo } from "../../utils/tokenHandler";

const AgenciesLayout = ({ children }) => {
  const hasToken = getUserToken();
  const { data: userDetails, refetch: refetchUserDetails } = useSessionUserDetails();

  useEffect(() => {
    if (userDetails?.is_sso_auth) {
      setCurrentFbo(null);
      if (!!hasToken) {
        refetchUserDetails();
        window.location.reload();
      }
    }
  }, [hasToken, refetchUserDetails]);

  return <>{children}</>;
};

export default AgenciesLayout;
